<template>
    <el-config-provider :locale="locale" :empty-values="['', undefined, null]">
        <router-view />
    </el-config-provider>
</template>

<script setup>
import useSettingsStore from "@/store/modules/settings";
import { handleThemeStyle } from "@/utils/theme";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
// 解决日期时间国际化问题
import "dayjs/locale/zh-cn";
const locale = ref(zhCn); //使用中文
onMounted(() => {
    nextTick(() => {
        //初始化主题样式
        handleThemeStyle(useSettingsStore().theme);
    });
});

// 解决tcplayer播放按钮点击失效
$('body').on('click', '.vjs-play-control', function() {
    try {
        $(this).off('click');
        const video = $(this).closest('.tcplayer').find('video').get(0);
        video.paused ? video.play() : video.pause();
        return false;
    } catch (e) {
    }
});
</script>

<style lang="scss">
.tcplayer-copyright-tip {
  position: absolute;
  z-index: 99;
  padding: 10px;
  
  > p {
    font-size: 18px;
    background: rgba(0, 0, 0, 0.6);
    padding: 8px;
    border-radius: 4px;
    line-height: 1.5;
    color: #ffffff;
    display: inline-block;
  }
}
</style>
